import React, { useEffect, useRef } from 'react';

// Renders trusted question/option/explanation HTML and typesets any LaTeX in it.
// LaTeX must use \( ... \) for inline and \[ ... \] for display math.
// MathJax itself is loaded once from public/index.html.
// Plain-text content (e.g. existing Biology questions) contains no delimiters,
// so there is nothing to typeset and it renders exactly as before.
function typeset(node) {
  if (!node) return;
  const MJ = window.MathJax;
  if (MJ && MJ.typesetPromise) {
    try { if (MJ.typesetClear) MJ.typesetClear([node]); } catch (e) { /* ignore */ }
    MJ.typesetPromise([node]).catch(() => { /* ignore render errors */ });
  }
}

export default function MathHtml({ html, tag = 'div', style, className }) {
  const ref = useRef(null);
  useEffect(() => { typeset(ref.current); }, [html]);
  return React.createElement(tag, {
    ref,
    style,
    className,
    dangerouslySetInnerHTML: { __html: html || '' },
  });
}
